export function formatMoneyString(value: number): string {
  if (!value) {
    return '0';
  }
  return value % 1 === 0 ? `${value}` : `${value.toFixed(2)}`;
}
